import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
const firebaseConfig = {
    apiKey: "AIzaSyDmthRVrXA1u9wz3DTqSGzz2gU7p5KkGoM",
    authDomain: "interpreto-9669e.firebaseapp.com",
    projectId: "interpreto-9669e",
    storageBucket: "interpreto-9669e.firebasestorage.app",
    messagingSenderId: "815837992136",
    appId: "1:815837992136:web:1180fd2417f1d02ea141fd",
    measurementId: "G-6147Z2G6XV"
};
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
